import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ErrorBoundary } from "@/components/error-boundary";
import { SessionProvider } from "@/context/session-context";
import { TransferProvider } from "@/context/transfer-context";
import { HomePage } from "@/pages/home-page";
import { TransferPage } from "@/pages/transfer-page";
import { PwaProvider } from "@/context/pwa-context";
import { PrivacyPage } from "@/pages/privacy-page";
import { InstallPage } from "@/pages/install-page";
import { NotFoundPage } from "@/pages/not-found-page";
export function App(){return <ErrorBoundary><PwaProvider><BrowserRouter><SessionProvider><TransferProvider><Routes><Route path="/" element={<HomePage/>}/><Route path="/transfer" element={<TransferPage/>}/><Route path="/privacy" element={<PrivacyPage/>}/><Route path="/install" element={<InstallPage/>}/><Route path="*" element={<NotFoundPage/>}/></Routes></TransferProvider></SessionProvider></BrowserRouter></PwaProvider></ErrorBoundary>}
